import { connect } from 'react-redux';
import { AppHeaderComp } from 'core';
import * as selectors from 'selectors';

const mapToProps = state => ({
  is_online: state.system.is_online,
  unread: selectors.getUnreadGroupCount() + selectors.getUnreadPMCount()
});

export const AppHeader = connect(mapToProps)(AppHeaderComp);



// WEBPACK FOOTER //
// ./src/containers/AppHeader.js